import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function LandingPage() {
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    hotel_name: '',
    message: ''
  })

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitSuccess, setSubmitSuccess] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      const response = await fetch('https://hotelcheck.online/api/leads', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })

      if (response.ok) {
        setSubmitSuccess(true)
        setFormData({
          name: '',
          phone: '',
          hotel_name: '',
          message: ''
        })
      } else {
        alert('Ошибка при отправке заявки. Попробуйте позже.')
      }
    } catch (error) {
      alert('Ошибка при отправке заявки. Попробуйте позже.')
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const scrollToDemo = () => {
    document
      .getElementById('demo')
      ?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">

      {/* Header */}
      <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">

          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-600 text-xl">
              🏨
            </div>

            <div>
              <div className="text-xl font-bold tracking-tight text-slate-900">
                HotelCheck
              </div>

              <div className="hidden text-xs text-slate-500 sm:block">
                Онлайн-регистрация гостей
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-3">

            <button
              onClick={() => navigate('/owner-login')}
              className="hidden rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 sm:block"
            >
              Вход владельца
            </button>

            <button
              onClick={() => navigate('/admin-login')}
              className="rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white transition hover:bg-slate-700 sm:px-4"
            >
              Вход для администратора
            </button>

          </div>
        </div>
      </header>


      {/* Hero */}
      <section className="overflow-hidden bg-white">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-24">

          <div>

            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-medium text-blue-700">
              <span className="h-2 w-2 rounded-full bg-blue-600"></span>
              Современная регистрация гостей
            </div>

            <h1 className="max-w-2xl text-4xl font-bold leading-tight tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
              Онлайн-регистрация гостей без лишней работы на ресепшн
            </h1>

            <p className="mt-6 max-w-xl text-lg leading-8 text-slate-600">
              Гость самостоятельно заполняет данные и загружает паспорт по QR-коду.
              HotelCheck подготавливает договор на заселение, а администратор
              проверяет готовый документ и распечатывает его.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">

              <button
                onClick={scrollToDemo}
                className="rounded-xl bg-blue-600 px-6 py-3.5 text-center font-semibold text-white shadow-lg shadow-blue-600/20 transition hover:bg-blue-700"
              >
                Запросить демонстрацию
              </button>

              <button
                onClick={() =>
                  document
                    .getElementById('how-it-works')
                    ?.scrollIntoView({ behavior: 'smooth' })
                }
                className="rounded-xl border border-slate-300 bg-white px-6 py-3.5 font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                Как это работает
              </button>

            </div>

            <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-sm text-slate-500">

              <div className="flex items-center gap-2">
                <span className="text-green-600">✓</span>
                QR-регистрация
              </div>

              <div className="flex items-center gap-2">
                <span className="text-green-600">✓</span>
                Автоматическая обработка данных
              </div>

              <div className="flex items-center gap-2">
                <span className="text-green-600">✓</span>
                Индивидуальный шаблон договора
              </div>

            </div>

          </div>


          {/* Hero visual */}
          <div className="relative">

            <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-blue-100 blur-3xl"></div>

            <div className="relative rounded-3xl border border-slate-200 bg-slate-50 p-5 shadow-2xl sm:p-8">

              <div className="mb-6 flex items-center justify-between">

                <div>
                  <div className="text-sm font-medium text-slate-500">
                    Сценарий регистрации
                  </div>

                  <div className="mt-1 text-xl font-bold text-slate-900">
                    От QR-кода до готового договора
                  </div>
                </div>

                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white text-2xl shadow-sm">
                  📄
                </div>

              </div>


              <div className="space-y-3">

                <div className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4">

                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-xl">
                    📱
                  </div>

                  <div>
                    <div className="font-semibold text-slate-900">
                      Гость сканирует QR-код
                    </div>

                    <div className="text-sm text-slate-500">
                      Открывает страницу онлайн-регистрации
                    </div>
                  </div>

                </div>


                <div className="ml-8 h-5 border-l-2 border-dashed border-blue-200"></div>


                <div className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4">

                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-xl">
                    📝
                  </div>

                  <div>
                    <div className="font-semibold text-slate-900">
                      Заполняет данные
                    </div>

                    <div className="text-sm text-slate-500">
                      Вручную или с помощью фотографии паспорта
                    </div>
                  </div>

                </div>


                <div className="ml-8 h-5 border-l-2 border-dashed border-blue-200"></div>


                <div className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4">

                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-purple-50 text-xl">
                    ⚙️
                  </div>

                  <div>
                    <div className="font-semibold text-slate-900">
                      HotelCheck подготавливает договор
                    </div>

                    <div className="text-sm text-slate-500">
                      Данные подставляются в шаблон вашего объекта
                    </div>
                  </div>

                </div>


                <div className="ml-8 h-5 border-l-2 border-dashed border-blue-200"></div>


                <div className="flex items-center gap-4 rounded-2xl border border-green-200 bg-green-50 p-4">

                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-green-100 text-xl">
                    ✓
                  </div>

                  <div>
                    <div className="font-semibold text-slate-900">
                      Администратор проверяет и печатает
                    </div>

                    <div className="text-sm text-slate-600">
                      Готовый документ появляется в личном кабинете
                    </div>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </section>


      {/* Problem */}
      <section className="bg-slate-50 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

          <div className="mx-auto max-w-3xl text-center">

            <div className="text-sm font-semibold uppercase tracking-wider text-blue-600">
              Проблема
            </div>

            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Администратор не должен тратить всё время на переписывание данных
            </h2>

            <p className="mt-5 text-lg leading-8 text-slate-600">
              Ручная регистрация каждого гостя занимает время и создаёт дополнительную
              нагрузку на сотрудников. Особенно в периоды высокой загрузки.
            </p>

          </div>


          <div className="mt-12 grid gap-6 md:grid-cols-3">

            <div className="rounded-2xl border border-slate-200 bg-white p-7">

              <div className="text-3xl">⏱️</div>

              <h3 className="mt-5 text-xl font-bold text-slate-900">
                Рутинная работа
              </h3>

              <p className="mt-3 leading-7 text-slate-600">
                Администратор тратит время на ручной ввод и переписывание данных
                вместо работы с гостями.
              </p>

            </div>


            <div className="rounded-2xl border border-slate-200 bg-white p-7">

              <div className="text-3xl">👥</div>

              <h3 className="mt-5 text-xl font-bold text-slate-900">
                Очереди при заселении
              </h3>

              <p className="mt-3 leading-7 text-slate-600">
                В часы пик несколько гостей одновременно ждут, пока сотрудник
                завершит регистрацию предыдущего.
              </p>

            </div>


            <div className="rounded-2xl border border-slate-200 bg-white p-7">

              <div className="text-3xl">✍️</div>

              <h3 className="mt-5 text-xl font-bold text-slate-900">
                Ручной ввод данных
              </h3>

              <p className="mt-3 leading-7 text-slate-600">
                Чем больше ручных операций, тем больше времени занимает обработка
                каждого заселения.
              </p>

            </div>

          </div>

        </div>
      </section>


      {/* Solution */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

          <div className="grid items-center gap-14 lg:grid-cols-2">

            <div>

              <div className="text-sm font-semibold uppercase tracking-wider text-blue-600">
                Решение
              </div>

              <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
                Гость заполняет данные сам. Администратор проверяет готовый результат.
              </h2>

              <p className="mt-6 text-lg leading-8 text-slate-600">
                HotelCheck переносит часть рутинной работы с регистрации на самого
                гостя. Вместо того чтобы сотрудник вручную заполнял все данные,
                гость проходит онлайн-регистрацию по QR-коду.
              </p>

              <div className="mt-8 space-y-5">

                <div className="flex gap-4">

                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-100 font-bold text-blue-700">
                    1
                  </div>

                  <div>
                    <h3 className="font-bold text-slate-900">
                      Гость проходит онлайн-регистрацию
                    </h3>

                    <p className="mt-1 text-slate-600">
                      Не нужно полностью заполнять данные за гостя на ресепшн.
                    </p>
                  </div>

                </div>


                <div className="flex gap-4">

                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-100 font-bold text-blue-700">
                    2
                  </div>

                  <div>
                    <h3 className="font-bold text-slate-900">
                      Система подготавливает документы
                    </h3>

                    <p className="mt-1 text-slate-600">
                      Данные обрабатываются и подставляются в шаблон договора вашего объекта.
                    </p>
                  </div>

                </div>


                <div className="flex gap-4">

                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-100 font-bold text-blue-700">
                    3
                  </div>

                  <div>
                    <h3 className="font-bold text-slate-900">
                      Администратор контролирует результат
                    </h3>

                    <p className="mt-1 text-slate-600">
                      Сотрудник проверяет готовый документ и печатает его.
                    </p>
                  </div>

                </div>

              </div>

            </div>


            <div className="rounded-3xl bg-slate-900 p-8 text-white shadow-xl sm:p-10">

              <div className="text-5xl">🏨</div>

              <h3 className="mt-8 text-2xl font-bold">
                HotelCheck работает под ваш объект
              </h3>

              <p className="mt-4 leading-7 text-slate-300">
                Перед началом работы мы настраиваем шаблон документов на основе
                договора вашего отеля или хостела.
              </p>

              <div className="mt-8 space-y-4">

                <div className="flex items-center gap-3">
                  <span className="text-green-400">✓</span>
                  Индивидуальный шаблон договора
                </div>

                <div className="flex items-center gap-3">
                  <span className="text-green-400">✓</span>
                  Настройка под процессы вашего объекта
                </div>

                <div className="flex items-center gap-3">
                  <span className="text-green-400">✓</span>
                  Работа через личный кабинет администратора
                </div>

              </div>

            </div>

          </div>

        </div>
      </section>


      {/* How it works */}
      <section id="how-it-works" className="bg-slate-50 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

          <div className="mx-auto max-w-3xl text-center">

            <div className="text-sm font-semibold uppercase tracking-wider text-blue-600">
              Как это работает
            </div>

            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              От QR-кода до готового договора
            </h2>

            <p className="mt-5 text-lg text-slate-600">
              Простой процесс для гостя и меньше рутинной работы для администратора.
            </p>

          </div>


          <div className="mt-14 grid gap-8 md:grid-cols-5">

            {[
              {
                number: '01',
                icon: '📱',
                title: 'QR-код',
                text: 'Гость сканирует QR-код и открывает страницу регистрации.'
              },
              {
                number: '02',
                icon: '📝',
                title: 'Данные',
                text: 'Заполняет необходимые данные самостоятельно.'
              },
              {
                number: '03',
                icon: '📄',
                title: 'Документ',
                text: 'Загружает фотографию паспорта для автоматического распознавания.'
              },
              {
                number: '04',
                icon: '⚙️',
                title: 'Обработка',
                text: 'Система подготавливает договор по шаблону объекта.'
              },
              {
                number: '05',
                icon: '✓',
                title: 'Проверка',
                text: 'Администратор проверяет документ и распечатывает его.'
              }
            ].map((step) => (

              <div
                key={step.number}
                className="relative rounded-2xl border border-slate-200 bg-white p-6"
              >

                <div className="text-sm font-bold text-blue-600">
                  {step.number}
                </div>

                <div className="mt-5 text-3xl">
                  {step.icon}
                </div>

                <h3 className="mt-5 font-bold text-slate-900">
                  {step.title}
                </h3>

                <p className="mt-2 text-sm leading-6 text-slate-600">
                  {step.text}
                </p>

              </div>

            ))}

          </div>

        </div>
      </section>


      {/* Security */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

          <div className="rounded-3xl border border-blue-100 bg-blue-50 p-8 sm:p-12">

            <div className="grid items-center gap-10 lg:grid-cols-2">

              <div>

                <div className="text-5xl">🔒</div>

                <h2 className="mt-6 text-3xl font-bold tracking-tight text-slate-900">
                  Фотография паспорта не хранится в системе
                </h2>

                <p className="mt-5 text-lg leading-8 text-slate-600">
                  Изображение документа используется для обработки данных.
                  После распознавания фотография удаляется, а готовый результат
                  используется для формирования документов на заселение.
                </p>

              </div>


              <div className="space-y-4">

                <div className="rounded-2xl bg-white p-5 shadow-sm">

                  <div className="flex items-start gap-4">

                    <div className="text-2xl">📷</div>

                    <div>
                      <h3 className="font-bold text-slate-900">
                        1. Гость загружает документ
                      </h3>

                      <p className="mt-1 text-sm text-slate-600">
                        Изображение используется для обработки данных.
                      </p>
                    </div>

                  </div>

                </div>


                <div className="rounded-2xl bg-white p-5 shadow-sm">

                  <div className="flex items-start gap-4">

                    <div className="text-2xl">⚙️</div>

                    <div>
                      <h3 className="font-bold text-slate-900">
                        2. Система обрабатывает данные
                      </h3>

                      <p className="mt-1 text-sm text-slate-600">
                        Информация используется для подготовки документов.
                      </p>
                    </div>

                  </div>

                </div>


                <div className="rounded-2xl bg-white p-5 shadow-sm">

                  <div className="flex items-start gap-4">

                    <div className="text-2xl">🗑️</div>

                    <div>
                      <h3 className="font-bold text-slate-900">
                        3. Фотография удаляется
                      </h3>

                      <p className="mt-1 text-sm text-slate-600">
                        В системе не хранится фотография паспорта после обработки.
                      </p>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </section>


      {/* For whom */}
      <section className="bg-slate-50 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

          <div className="mx-auto max-w-3xl text-center">

            <div className="text-sm font-semibold uppercase tracking-wider text-blue-600">
              Для бизнеса
            </div>

            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Подходит для разных форматов размещения
            </h2>

          </div>


          <div className="mt-12 grid gap-6 md:grid-cols-3">

            <div className="rounded-2xl border border-slate-200 bg-white p-7">

              <div className="text-4xl">🏨</div>

              <h3 className="mt-5 text-xl font-bold text-slate-900">
                Отели
              </h3>

              <p className="mt-3 leading-7 text-slate-600">
                Упростите процесс регистрации гостей и сократите количество
                ручных операций на ресепшн.
              </p>

            </div>


            <div className="rounded-2xl border border-slate-200 bg-white p-7">

              <div className="text-4xl">🛏️</div>

              <h3 className="mt-5 text-xl font-bold text-slate-900">
                Хостелы
              </h3>

              <p className="mt-3 leading-7 text-slate-600">
                Помогите администраторам справляться с большим потоком гостей
                без постоянного ручного ввода данных.
              </p>

            </div>


            <div className="rounded-2xl border border-slate-200 bg-white p-7">

              <div className="text-4xl">🏢</div>

              <h3 className="mt-5 text-xl font-bold text-slate-900">
                Апарт-отели
              </h3>

              <p className="mt-3 leading-7 text-slate-600">
                Организуйте удобную онлайн-регистрацию для гостей до их прибытия
                или непосредственно на объекте.
              </p>

            </div>

          </div>

        </div>
      </section>


      {/* Demo CTA */}
      <section id="demo" className="bg-slate-900 py-20 text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

          <div className="grid gap-14 lg:grid-cols-2 lg:items-center">

            <div>

              <div className="text-sm font-semibold uppercase tracking-wider text-blue-400">
                Демонстрация
              </div>

              <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
                Посмотрите HotelCheck в работе
              </h2>

              <p className="mt-6 text-lg leading-8 text-slate-300">
                Мы покажем весь путь регистрации: от сканирования QR-кода гостем
                до появления готового договора в личном кабинете администратора.
              </p>

              <div className="mt-8 space-y-4 text-slate-300">

                <div className="flex items-center gap-3">
                  <span className="text-green-400">✓</span>
                  Покажем сценарий регистрации гостя
                </div>

                <div className="flex items-center gap-3">
                  <span className="text-green-400">✓</span>
                  Покажем личный кабинет администратора
                </div>

                <div className="flex items-center gap-3">
                  <span className="text-green-400">✓</span>
                  Обсудим настройку шаблона документов вашего объекта
                </div>

              </div>

            </div>


            <div className="rounded-3xl bg-white p-6 shadow-2xl sm:p-8">

              <h3 className="text-2xl font-bold text-slate-900">
                Запросить демонстрацию
              </h3>

              <p className="mt-2 text-slate-600">
                Оставьте контакты — мы свяжемся с вами и договоримся о демонстрации.
              </p>


              {submitSuccess ? (

                <div className="mt-6 rounded-2xl border border-green-200 bg-green-50 p-6 text-center">

                  <div className="text-3xl">✓</div>

                  <div className="mt-3 font-semibold text-green-800">
                    Заявка отправлена
                  </div>

                  <div className="mt-1 text-sm text-green-700">
                    Мы свяжемся с вами в ближайшее время.
                  </div>

                </div>

              ) : (

                <form onSubmit={handleSubmit} className="mt-6 space-y-4">

                  <div>

                    <label className="mb-1.5 block text-sm font-medium text-slate-700">
                      Ваше имя *
                    </label>

                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                      placeholder="Иван"
                    />

                  </div>


                  <div>

                    <label className="mb-1.5 block text-sm font-medium text-slate-700">
                      Телефон *
                    </label>

                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                      placeholder="+7 (999) 123-45-67"
                    />

                  </div>


                  <div>

                    <label className="mb-1.5 block text-sm font-medium text-slate-700">
                      Название отеля или хостела *
                    </label>

                    <input
                      type="text"
                      name="hotel_name"
                      value={formData.hotel_name}
                      onChange={handleChange}
                      required
                      className="w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                      placeholder="Название объекта"
                    />

                  </div>


                  <div>

                    <label className="mb-1.5 block text-sm font-medium text-slate-700">
                      Комментарий
                    </label>

                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows={3}
                      className="w-full resize-none rounded-xl border border-slate-300 px-4 py-3 text-slate-900 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                      placeholder="Количество номеров, мест или другие детали"
                    />

                  </div>


                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full rounded-xl bg-blue-600 px-6 py-3.5 font-semibold text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-slate-400"
                  >
                    {isSubmitting
                      ? 'Отправка...'
                      : 'Запросить демонстрацию'}
                  </button>

                </form>

              )}

            </div>

          </div>

        </div>
      </section>


      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white">

        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-8 text-sm text-slate-500 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">

          <div>
            © 2026 HotelCheck
          </div>

          <div>
            Онлайн-регистрация гостей для отелей и хостелов
          </div>

        </div>

      </footer>

    </div>
  )
}